import { PriceNote } from "../types/price-note";
import { IDevelopmentPriceNoteService } from "../types/services/development-price-note-service";
import { FetchResult, GET, POST } from "../utils/fetch";

type PriceNotesResponse = {
  price_notes: PriceNote[];
};

class DevelopmentPriceNoteService implements IDevelopmentPriceNoteService {
  async getPriceNotes(propertyId: number): Promise<FetchResult<PriceNote[]>> {
    const url = `/api/v2/development/properties/${propertyId}/price_notes`,
      { response, error } = await GET<PriceNotesResponse>(url);

    if (error) {
      return { response: null, error };
    }

    if (!response) {
      return { response: null, error: new Error("Unknown error") };
    }

    return { response: response.price_notes, error: null };
  }

  async addPriceNote(
    propertyId: number,
    value: number,
  ): Promise<FetchResult<PriceNote[]>> {
    const url = `/api/v2/development/properties/${propertyId}/price_notes`,
      { response, error } = await POST<PriceNotesResponse>(url, { value });

    if (error) {
      return { response: null, error };
    }

    if (!response) {
      return { response: null, error: new Error("Unknown error") };
    }

    return { response: response.price_notes, error: null };
  }
}

export default DevelopmentPriceNoteService;
